import { styled as n } from "styled-components";
const t = n.h4`
  ${({ theme: o }) => {
  var r, i;
  return (i = (r = o == null ? void 0 : o.get) == null ? void 0 : r.call(o, "tokens.body.compact-expressive")) == null ? void 0 : i.toJS();
}}
  color: ${({ $colorTheme: o = "light", theme: r }) => r == null ? void 0 : r.get(`tokens.text.${o}.primary`)};
  margin: 0;
  text-align: center;
  width: 100%;
`;
export {
  t as MonthLabel
};
